export enum LanguageType {
  Ko = 'ko',
  En = 'en',
  Jp = 'jp',
  Fr = 'fr'
}

export enum TooningGoLink {
  play = 'play',
  magic = 'magic',
  meme = 'meme',
  character = 'character',
  world = 'world'
}

export enum PlatformType {
  Edu = 'edu',
  Plus = 'plus'
}

export enum MediaType {
  Image = 'image',
  Video = 'video'
}

export enum ServiceType {
  Chat = 'chat',
  Character = 'character',
  Magic = 'magic',
  Editor = 'editor',
  Board = 'board',
  Stories = 'stories',
  Studio = 'studio',
  PlusEditor = 'plusEditor',
  Deev = 'deev'
}

export enum SnsType {
  Facebook = 'facebook',
  Naver = 'naver',
  Instagram = 'instagram',
  Youtube = 'youtube',
  Github = 'github'
}

export enum MenuType {
  About = 'about',
  Member = 'member',
  History = 'history',
  News = 'news'
}
